import { render, staticRenderFns } from "./apiproductchannelreport.vue?vue&type=template&id=1b17f47f&"
import script from "./apiproductchannelreport.vue?vue&type=script&lang=js&"
export * from "./apiproductchannelreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports